module.exports = "/assets/data/7b498b3d34ad4c99eaa30f1cd18fb2d3-B36.data.json";